<template lang="pug">
  div#vip
    div.f16.white(v-if='back' @click='onBack') 返回
    img(src='/static/images/stu/vip/vip1.png')
    img(src='/static/images/stu/vip/vip6.png')
    img(src='/static/images/stu/vip/vip2.png')
    button(@click='handleShowVipModal')
    img(src='/static/images/stu/vip/vip3.png')
    img.mt20(src='/static/images/stu/vip/vip4.png')
    img.mt50(src='/static/images/stu/vip/vip5.png')
    div.call
      p.tc 在购买会员或VIP适用过程中，如有问题欢迎联系我们。
      p.tc(style="margin-top:6px") 全国客服热线：400-018-9011 （周一至周日 9：00-21：00）
</template>

<script>
export default {
  name: 'NoPain',
  props: ['back', 'onBack'],
  methods: {
    handleShowVipModal() {
      this.$store.commit('toggleChargeModel')
    }
  }
}
</script>

<style lang="less">
.tc {
  text-align: center;
}
#vip {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background-color: #fff;
  overflow: hidden;

  & > div {
    position: absolute;
    top: 24px;
    left: 20px;
    padding-left: 24px;
    background: url('/static/images/stu/vip/btn03.png') no-repeat left center;
    cursor: pointer;
  }

  button {
    width: 500px;
    height: 122px;
    border: 0;
    background-color: transparent;
    background-image: url('/static/images/stu/vip/btn_normal.png');
    margin-bottom: 50px;

    &:hover {
      background-image: url('/static/images/stu/vip/btn_hover.png');
      cursor: pointer;
    }
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt50 {
    margin-top: 50px;
  }
  .call {
    position: static;
    margin-top: 20px;
    margin-bottom: 20px;
    p {
      font-size: 14px;
      color: #666;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/vip/index.vue